<div class="area-list">
    <div class="user-management-heading-info">
       <div class="align-h width-stretch">
          <div class="stretch">Region Name</div>
          <div class="stretch">Region ID</div>
          <div class="form-group stretch">
             <mat-form-field>
                <input placeholder="Search by Region Name" matInput [(ngModel)]="searchByName" name="search" #search="ngModel">
                <mat-icon matSuffix>search</mat-icon>
             </mat-form-field>
          </div>
          <div class="margin-right-10"></div>
       </div>
    </div>
    <ng-template ngFor let-region [ngForOf]="regionList | searchFilter: ['regionName']:searchByName">
       <div class="align-h width-stretch margin-bottom-20 area-list-layout">
          <div class="stretch margin-left-15">{{ region.regionName }}</div>
          <div class="stretch">{{ region.regionId }}</div>
          <div class="align-h width-215">
             <div class="stretch">
                <a
                   mat-flat-button
                   (click)="$event.stopPropagation();onEditRegion(region)"
                   >
                <img
                   src="assets/images/Edit.png"
                   alt="Edit"
                   >
                </a>
             </div>
             <div class="stretch">
                <a
                   mat-flat-button
                   (click)="$event.stopPropagation();openDeleteDialog(region)"
                   >
                <img
                   src="assets/images/Delete.png"
                   alt="Delete"
                   >
                </a>
             </div>
          </div>
       </div>
    </ng-template>
    <div class="no-data" *ngIf="(regionList | searchFilter:['regionName']:searchByName)?.length === 0 ">No data found!!!</div>
 </div>